import React from 'react'
import { TextInput } from '@/components'
import { t } from '@/i18n'
import CarSubModelSelector from '@/pages/Car/carSubModelSelector'
import { IProposal } from '@/types'

interface Props {
  isEditing?: boolean
  emptyValue?: string | null
  children?: React.ReactNode
  loading: boolean
  initialData?: Partial<IProposal>
  onTriggerChange: (f: string, v: any) => void

  [x: string]: any
}


const ProposalCarFormComponents: React.FC<Props> = ({
  isEditing,
  emptyValue,
  loading,
  initialData,
  onTriggerChange,
  ...props
}) => {
  return (
    <>
      <TextInput
        {...props}
        name="modelYear"
        type="number"
        min={0}
        emptyValue={emptyValue}
        disabled={!Boolean(isEditing)}
        label={t('model_year')}
      />
      <TextInput
        {...props}
        name="freeKmPerYear"
        type="number"
        emptyValue={emptyValue}
        disabled={!Boolean(isEditing)}
        label={t('free_km_per_year')}
      />
      <CarSubModelSelector
        {...props}
        isFormElement
        loading={loading}
        isEditing={isEditing}
        initialBrand={initialData?.carSubModel?.carModel?.brand}
        initialModel={initialData?.carSubModel?.carModel}
        initialSubModel={initialData?.carSubModel}
        onTriggerChange={onTriggerChange}
      />
    </>
  )
}

export default ProposalCarFormComponents
